import Reactive from '../general/reactive';

class StreamManager extends Reactive {
  constructor(params) {
    super(params);

    this.prop('ro', 'MANAGER', 'self');
    this.prop('rw', 'streams', {});
    this.prop('rw', 'constraintsUpdated', false);
    // count is kind of a semaphore, this is used to wait until
    // all the streams are set before Setting the tracks in the
    // Peer connection
    this.prop('rw', 'count', 0);

    this.debugLog = false;
  }

  // methods:

  addStream(stream) { // add stream of type Stream
    // ensure stream is of type Stream thru DuckTyping
    this.streams[stream.label] = stream;

    stream.on('errorGettingStream', () => {
      this.update({ count: this.count - 1 });
      if (this.count == 0) {
        this.log('ERROR: FINISHED GETTING STREAMS');
        this.emit('FINISHED_GETTING_STREAMS');
      }
    });
    stream.on('GOT_STREAM', (label, mediaStream) => {
      this.log('got stream', this.count);
      this.emit('GOT_STREAM', label, mediaStream);
      this.update({ count: this.count - 1 });
      if (this.count == 0) {
        this.log('FINISHED GETTING STREAMS');
        this.emit('FINISHED_GETTING_STREAMS');
      }
    });

    this.update({ constraintsUpdated: true });
  }

  removeStream(label) {
    delete this.streams[label];
  }

  removeAllStreams() {
    Object.keys(this.streams).forEach((label) => {
      this.streams[label].stop();
      // set constraints as changed to force to ask again the tracks
      this.streams[label].update({ constraintsChanged: true });
    });
    // set constraints as changed to force a reconnect
    this.update({ constraintsUpdated: true });
  }

  refresh() { // Update constraints
    let validStreamsCount = 0;
    Object.keys(this.streams).forEach((label) => {
      if (this.streams[label].constraintsChanged == true && this.streams[label].constraints != false) {
        validStreamsCount++;
      }
    });

    this.update({ count: validStreamsCount }); // reset the count as this is a new request
    Object.keys(this.streams).forEach((label) => {
      this.streams[label].refresh();
    });
    if (this.count == 0) {
      this.log('REFRESH: FINISHED GETTING STREAMS');
      this.emit('FINISHED_GETTING_STREAMS');
    }
	 this.emit('refreshed');
  }

  setConstraints(label, constraints) {
    this.update({ constraintsUpdated: true });
    if (typeof this.streams[label] !== 'undefined') this.streams[label].setConstraints(constraints);
  }

  getStream(label) {
	  return this.streams[label];
  }

  getTracks(peerRole, myRole) {
    this.log('Getting tracks', peerRole, myRole);
    return [
      this.streams.CAMERA_AUDIO,
      this.streams.LOCAL_AUDIO,
      this.streams.TALENT_AUDIO,
      this.streams.CAMERA_VIDEO,
      this.streams.SCREEN_VIDEO,
    ];
  }

  resetSenders() {
    Object.keys(this.streams).forEach((label) => {
      this.streams[label].update({ senders: {} });
    });
  }

  log() {
    if (!this.debugLog) { return; }

    const PREFIX = '[StreamManager]';
    const args = [];
    args.push(PREFIX);
    for (let i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    console.log.apply(console, args);
  }

  // events
  // Stream refreshed
}

// create singleton of this stream manager

const StreamManagerSingleton = new StreamManager();
Object.freeze(StreamManagerSingleton);

export default StreamManagerSingleton;
